import { render } from "./Admin_Agregar_Proveedor.vue?vue&type=template&id=4231db88"
import script from "./Admin_Agregar_Proveedor.vue?vue&type=script&lang=js"
export * from "./Admin_Agregar_Proveedor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__